import { NgIf } from '@angular/common';
import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'shared-button-loader',
  templateUrl: './button-loader.component.html',
  styleUrls: ['./button-loader.component.css'],
  standalone: true,
  imports: [NgIf]
})
export class ButtonLoaderComponent {
  @Input() buttonType: string = 'button'; // Default to 'button' type
  @Input() buttonClass: string = '';
  @Input() disabled: boolean = false;
  @Output() loadingStarted: EventEmitter<void> = new EventEmitter<void>();
  public loading: boolean = false;

  loaderClicked(): void {
    this.loadingStarted.emit()
  }
}
